"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlsGeneralTableControl = void 0;
const DOM_1 = require("../../../../public/js/utils/DOM");
const EasyFilterControl_1 = require("../EasyFilterControl/EasyFilterControl");
const FilterControl_1 = require("../FilterControl/FilterControl");
const Table_1 = require("../../../../public/js/utils/Table");
const DropDownControl_1 = require("../DropDownControl/DropDownControl");
const Netwtorking_1 = require("../../../../public/js/utils/Netwtorking");
const RequestTypes_1 = require("../../../../public/js/definitions/utils/networking/RequestTypes");
const LinkBuilder_1 = require("../../../../public/js/utils/LinkBuilder");
const Form_1 = require("../../Form/Form");
const FormValidator_1 = require("../../../../public/js/utils/Validator/FormValidator");
var ControlsGeneralTableControl;
(function (ControlsGeneralTableControl) {
    class Config {
        static triggerRowTitle = 'TableControl-mobile-content-item-main';
        static openedRowClassName = 'opened';
        static tableControlElementClassName = "TableControl";
        static copyColumnClassName = 'columnCopy';
        static copyColumnButtonClassName = 'columnCopy-btn';
        static copyColumnContentClassName = 'columnCopy-content';
        static copyColumnCopiedClassName = 'copied';
    }
    ControlsGeneralTableControl.Config = Config;
    class Filter {
        static triggerEasyFilterFilter(filterRequest, easyFilterId, filterId, dropdownId) {
            EasyFilterControl_1.ControlsGeneralEasyFilterControl.Control.initialize({
                easyFilterId: easyFilterId,
                callback: (actionTypeId, event) => {
                    void this.sendFilterRequest({
                        filter: filterId ? FilterControl_1.ControlsGeneralFilterControl.Utils.getFilterDataByFilterId(filterId) : null,
                        linkParams: { component: filterRequest.componentNameIncluded, method: filterRequest.filterBackendCallback, parameters: [] },
                        page: 0,
                        sorting: Table_1.Table.Helpers.getSorting(filterRequest.tableId),
                        event: event,
                        dropDownValue: dropdownId ? DropDownControl_1.DropDownControl.Control.getCurrentDropDownValue(dropdownId) : null,
                        easyFilterTypeId: actionTypeId,
                        completedCallback: () => { filterRequest.successCallback(); }
                    });
                }
            });
        }
        static triggerDropdownFilter(filterRequest, dropdownId, filterId, easyFilterId) {
            if (document.getElementById(dropdownId)) {
                DropDownControl_1.DropDownControl.Control.trigger(dropdownId, (valueToPropagate, event) => {
                    void this.sendFilterRequest({
                        filter: filterId ? FilterControl_1.ControlsGeneralFilterControl.Utils.getFilterDataByFilterId(filterId) : null,
                        linkParams: { component: filterRequest.componentNameIncluded, method: filterRequest.filterBackendCallback, parameters: [] },
                        page: 0,
                        sorting: Table_1.Table.Helpers.getSorting(filterRequest.tableId),
                        event: event,
                        dropDownValue: valueToPropagate,
                        easyFilterTypeId: easyFilterId ? EasyFilterControl_1.ControlsGeneralEasyFilterControl.Control.getEasyFilterType(easyFilterId) : null,
                        completedCallback: () => { filterRequest.successCallback(); }
                    });
                });
            }
        }
        static triggerChangePageFilter(filterRequest, dropdownId, filterId, easyFilterId) {
            this.triggerChangePage((event, page) => {
                void this.sendFilterRequest({
                    filter: filterId ? FilterControl_1.ControlsGeneralFilterControl.Utils.getFilterDataByFilterId(filterId) : null,
                    linkParams: { component: filterRequest.componentNameIncluded, method: filterRequest.filterBackendCallback, parameters: [] },
                    page: page,
                    sorting: Table_1.Table.Helpers.getSorting(filterRequest.tableId),
                    event: event,
                    dropDownValue: dropdownId ? DropDownControl_1.DropDownControl.Control.getCurrentDropDownValue(dropdownId) : null,
                    easyFilterTypeId: easyFilterId ? EasyFilterControl_1.ControlsGeneralEasyFilterControl.Control.getEasyFilterType(easyFilterId) : null,
                    completedCallback: () => { filterRequest.successCallback(); }
                });
            });
        }
        static triggerChangePage(callback) {
            const pages = DOM_1.DOM.Parser.getHtmlElements('TableControl-pagination-inside-right-content-item-text', undefined, true);
            for (let i = 0; i < pages.length; i++) {
                pages[i].addEventListener("click", (event) => {
                    const page = parseInt(DOM_1.DOM.Parser.getDataByNameFromElement('page', pages[i]));
                    callback(event, page);
                });
            }
        }
        static triggerSortFilter(filterRequest, dropdownId, filterId, easyFilterId) {
            const tableElement = document.getElementById(filterRequest.tableId);
            if (tableElement === null) {
                return;
            }
            Table_1.Table.Helpers.triggerOnSorting(tableElement, (sorting, event) => {
                void this.sendFilterRequest({
                    filter: filterId ? FilterControl_1.ControlsGeneralFilterControl.Utils.getFilterDataByFilterId(filterId) : null,
                    linkParams: { component: filterRequest.componentNameIncluded, method: filterRequest.filterBackendCallback, parameters: [] },
                    page: 0,
                    sorting: sorting,
                    event: event,
                    dropDownValue: dropdownId ? DropDownControl_1.DropDownControl.Control.getCurrentDropDownValue(dropdownId) : null,
                    easyFilterTypeId: easyFilterId ? EasyFilterControl_1.ControlsGeneralEasyFilterControl.Control.getEasyFilterType(easyFilterId) : null,
                    completedCallback: () => { filterRequest.successCallback(); }
                });
            });
        }
        static triggerFilterFilter(filterRequest, filterId, dropdownId, easyFilterId) {
            new FilterControl_1.ControlsGeneralFilterControl.Control(filterId, filterRequest.componentNameIncluded, (event) => {
                void this.sendFilterRequest({
                    filter: FilterControl_1.ControlsGeneralFilterControl.Utils.getFilterDataByFilterId(filterId),
                    linkParams: { component: filterRequest.componentNameIncluded, method: filterRequest.filterBackendCallback, parameters: [] },
                    page: 0,
                    sorting: Table_1.Table.Helpers.getSorting(filterRequest.tableId),
                    event: event,
                    dropDownValue: dropdownId ? DropDownControl_1.DropDownControl.Control.getCurrentDropDownValue(dropdownId) : null,
                    easyFilterTypeId: easyFilterId ? EasyFilterControl_1.ControlsGeneralEasyFilterControl.Control.getEasyFilterType(easyFilterId) : null,
                    completedCallback: () => { filterRequest.successCallback(); }
                }, filterId);
            }, filterRequest.successCallback);
        }
        static triggerFilterTable(filterRequest, filterId, dropdownId, easyFilterId) {
            if (filterId) {
                this.triggerFilterFilter(filterRequest, filterId, dropdownId, easyFilterId);
            }
            if (dropdownId) {
                this.triggerDropdownFilter(filterRequest, dropdownId, filterId, easyFilterId);
            }
            if (easyFilterId) {
                this.triggerEasyFilterFilter(filterRequest, easyFilterId, filterId, dropdownId);
            }
            this.triggerChangePageFilter(filterRequest, dropdownId, filterId, easyFilterId);
            this.triggerSortFilter(filterRequest, dropdownId, filterId, easyFilterId);
        }
        static async sendFilterRequest(filterRequest, filterId) {
            if (filterId) {
                void Form_1.ControlsForm.Controller.sendFormDataRequest(DOM_1.DOM.Parser.getElementByTag('form', DOM_1.DOM.Parser.getHtmlElement(filterId)), {
                    linkParameters: filterRequest.linkParams,
                    formData: { ...filterRequest.filter, ...{
                            page: filterRequest.page,
                            sorting: filterRequest.sorting,
                            multiEditActive: filterRequest.multiEditActive ?? null,
                            easyFilterTypeId: filterRequest.easyFilterTypeId,
                            dropDownValue: filterRequest.dropDownValue ?? null,
                            filterActive: !filterId ? false : FilterControl_1.ControlsGeneralFilterControl.Utils.getFilterActiveByFilterId(filterId),
                        } },
                    event: filterRequest.event,
                    startCallback: () => {
                        FilterControl_1.ControlsGeneralFilterControl.Utils.disableEnableActionsInFilter(filterId, true);
                    },
                    successCallback: () => {
                        if (filterRequest.successCallback) {
                            filterRequest.successCallback();
                        }
                    },
                    completedCallback: () => {
                        if (filterRequest.completedCallback) {
                            FilterControl_1.ControlsGeneralFilterControl.Utils.disableEnableActionsInFilter(filterId, false);
                            filterRequest.completedCallback();
                        }
                    }
                });
            }
            else {
                void Netwtorking_1.Networking.NetworkingController.createRequest({
                    type: RequestTypes_1.RequestTypes.POST,
                    data: { ...filterRequest.filter, ...{
                            page: filterRequest.page,
                            sorting: filterRequest.sorting,
                            easyFilterTypeId: filterRequest.easyFilterTypeId,
                            dropDownValue: filterRequest.dropDownValue ?? null,
                            multiEditActive: filterRequest.multiEditActive ?? null,
                            filterActive: false
                        }
                    },
                    url: LinkBuilder_1.LinkBuilder.LinkBuilderController.composeLink(filterRequest.linkParams),
                    completedCallback: () => { if (filterRequest.completedCallback) {
                        filterRequest.completedCallback();
                    } }
                });
            }
        }
        static triggerClearFilter(filterFormClear, component, successCallback) {
            filterFormClear.addEventListener('click', (event) => {
                event.stopPropagation();
                event.preventDefault();
                void Netwtorking_1.Networking.NetworkingController.createRequest({
                    type: RequestTypes_1.RequestTypes.GET,
                    url: LinkBuilder_1.LinkBuilder.LinkBuilderController.composeLink({ component: component, method: "ClearFilter", parameters: [] }),
                    successCallback: () => { successCallback(); }
                });
            });
        }
        static triggerSendFilter(filterFormElement, filterFormSubmit, callback) {
            FormValidator_1.FormValidator.validateForm({ form: filterFormElement, forceSubmitButton: filterFormSubmit });
            filterFormSubmit.addEventListener('click', (event) => { callback(event); });
        }
    }
    ControlsGeneralTableControl.Filter = Filter;
    class Control {
        static trigger(tableId, inside) {
            const tableList = this.getTableElementList(tableId ?? null, inside ?? null);
            this.triggerMobileRowShowHideAction(tableList);
            this.triggerCopy(tableList);
        }
        static getTableElementList(tableId, inside) {
            if (tableId) {
                return [DOM_1.DOM.Parser.getHtmlElement(tableId, inside ?? document.documentElement)];
            }
            const elements = DOM_1.DOM.Parser.getHtmlElements(Config.tableControlElementClassName, inside ?? document.documentElement);
            const output = [];
            for (let i = 0; i < elements.length; i++) {
                output.push(elements[i]);
            }
            return output;
        }
        static triggerMobileRowShowHideAction(triggerTables) {
            for (const table of triggerTables) {
                const triggerRows = DOM_1.DOM.Parser.getHtmlElements(Config.triggerRowTitle, table, true);
                for (let i = 0; i < triggerRows.length; i++) {
                    const row = triggerRows[i];
                    row.addEventListener('click', (event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        row.parentElement.classList.toggle(Config.openedRowClassName);
                    });
                }
            }
        }
        static triggerCopy(triggerTables) {
            for (const table of triggerTables) {
                const copyColumns = table.querySelectorAll('.' + Config.copyColumnClassName);
                if (copyColumns.length === 0) {
                    continue;
                }
                const content = DOM_1.DOM.Parser.getHtmlElementByClass(Config.copyColumnContentClassName);
                const button = DOM_1.DOM.Parser.getHtmlElementByClass(Config.copyColumnButtonClassName);
                button.addEventListener('click', (event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    void navigator.clipboard.writeText(content.innerText);
                    content.classList.add(Config.copyColumnCopiedClassName);
                    setTimeout(function () { content.classList.remove(Config.copyColumnCopiedClassName); }, 500);
                });
            }
        }
    }
    ControlsGeneralTableControl.Control = Control;
})(ControlsGeneralTableControl || (exports.ControlsGeneralTableControl = ControlsGeneralTableControl = {}));
